import React, { useEffect, useState } from "react";
import { Badge, Button, Card, CardBody, Col, Container, Input, Label, Row, Spinner } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { loadVisibleEncheres } from "../encheres/enchereService";
import { loadFerrailleurs } from "../reseau/reseauService";

const statusColor = {
  PROGRAMMEE: "info",
  A_VENIR: "primary",
  EN_COURS: "success",
  CLOTUREE: "secondary",
};
const firstVehiclePhoto = (enchere) => (enchere?.vehiculePhotos || []).find((photo) => photo?.path)?.path;

function FerrailleurEncheresVisiblesPage() {
  const [ferrailleurs, setFerrailleurs] = useState([]);
  const [ferrailleurId, setFerrailleurId] = useState("");
  const [encheres, setEncheres] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFerrailleurs().then((response) => {
      const list = response?.data?.body || [];
      setFerrailleurs(list);
      if (list[0]?.id) setFerrailleurId(String(list[0].id));
    });
  }, []);

  useEffect(() => {
    if (ferrailleurId) {
      setLoading(true);
      loadVisibleEncheres(ferrailleurId)
        .then((response) => setEncheres(response?.data?.body || []))
        .finally(() => setLoading(false));
    }
  }, [ferrailleurId]);

  return (
    <div className="page-content auction-page">
      <Container fluid>
        <Breadcrumbs title="Enchères visibles" breadcrumbItems={[{ title: "Férailleurs", link: "#" }, { title: "Enchères visibles", link: "#" }]} />
        <Card className="mb-4">
          <CardBody>
            <Row className="g-3 align-items-end">
              <Col lg={7}>
                <h4 className="mb-1">Enchères visibles</h4>
                <p className="text-muted mb-0">Liste filtrée selon le groupe et les ciblages du férailleur.</p>
              </Col>
              <Col lg={5}>
                <Label>Profil férailleur</Label>
                <Input type="select" value={ferrailleurId} onChange={(event) => setFerrailleurId(event.target.value)}>
                  {ferrailleurs.map((ferrailleur) => <option key={ferrailleur.id} value={ferrailleur.id}>{ferrailleur.nom}</option>)}
                </Input>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {loading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
          <Row className="g-3">
            {encheres.map((enchere) => (
              <Col xl={4} md={6} key={enchere.id}>
                <Card className="h-100 auction-card">
                  <CardBody>
                    {firstVehiclePhoto(enchere) && (
                      <img className="auction-vehicle-photo mb-3" src={firstVehiclePhoto(enchere)} alt={enchere.vehiculeLabel || enchere.titre || "Vehicule"} />
                    )}
                    <div className="d-flex justify-content-between gap-3 mb-3">
                      <div>
                        <h5 className="mb-1">{enchere.titre || enchere.vehiculeLabel || "Enchère"}</h5>
                        <div className="text-muted small">{enchere.vehiculeLabel || "Sans vehicule"}</div>
                      </div>
                      <Badge color={statusColor[enchere.status] || "secondary"}>{enchere.status}</Badge>
                    </div>
                    <Row className="g-3 mb-3">
                      <Col xs={6}><span className="text-muted small">Prix depart</span><strong>{enchere.prixDepart || "-"} MAD</strong></Col>
                      <Col xs={6}><span className="text-muted small">Pas</span><strong>{enchere.pasMinimal || "-"} MAD</strong></Col>
                      <Col xs={6}><span className="text-muted small">Debut</span><strong>{enchere.dateDebut || "-"}</strong></Col>
                      <Col xs={6}><span className="text-muted small">Fin</span><strong>{enchere.dateFin || "-"}</strong></Col>
                    </Row>
                    <Button color="primary" disabled={enchere.status !== "EN_COURS"} className="w-100">
                      <i className="ri-auction-line me-1"></i>
                      Participer
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            ))}
            {!encheres.length && <Col><Card><CardBody className="text-center py-5 text-muted">Aucune enchère visible pour ce profil.</CardBody></Card></Col>}
          </Row>
        )}
      </Container>
    </div>
  );
}

export default FerrailleurEncheresVisiblesPage;
